import React from "react";

interface FormProps {
  children: React.ReactNode;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => Promise<void> | void;
}

const Form = ({ children, onSubmit }: FormProps) => {
  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-3 items-center">
      {children}
    </form>
  );
};

export default Form;
